import { useState, useEffect, useCallback } from 'react';
import { DateTime } from 'luxon';

export function TimeLapsed({ startTime }) {
    const [timeLapsed, setTimeLapsed] = useState();
    const startedAt = DateTime.fromISO(startTime);

    const updateTimelapsed = useCallback(() => {
        const nowIso = DateTime.now();
        const diff = nowIso.diff(startedAt, ['minutes', 'seconds']);

        setTimeLapsed(diff.toFormat("m'min' s's'"));
    }, [startedAt]);

    useEffect(() => {
        updateTimelapsed();

        const interval = setInterval(updateTimelapsed, 1000);

        return () => clearInterval(interval);
    }, [startedAt, updateTimelapsed]);

    return <time>{timeLapsed}</time>;
}
